import { useQuery } from '@tanstack/react-query';
import React, { useContext, useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import { fetchProgramById } from '../../api/programmation';
import { adminProgrammeEditLink, adminProgrammeLink } from '../../constants/endspoints';
import Carousel from 'react-multi-carousel';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import ProgramCard from '../../components/ProgramCard';
import ProgramPlaceholder from '../../components/ProgramPlaceholder';
import { AppContexte } from '../../contexts/context';




const ProgrammationDetails = () => {

    const {id:programId} = useParams()

    const { max } = useContext(AppContexte)

    // Fetch a single program by ID
    const { data: singleProgram, isLoading: isFetchingSingle } = useQuery({
        queryKey: ['programU', programId],
        queryFn: () => fetchProgramById(programId),
        enabled: !!programId,
    });


    const responsivePrograms = {
        desktop1: {
            breakpoint: { max: 6000, min: 1200 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1200, min: 970 },
            items: 3,
        },
        tablet1: {
            breakpoint: { max: 970, min: 747 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 747, min: 440 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 440, min: 110 },
            items: 1,
        }
    }    

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    
    return (
        <div>
            <h1 className='fs-3 fw-bold mb-3'> <NavLink className={'fs-3 fw-bold text-white'} to={adminProgrammeLink}>Programmation</NavLink> / Détails</h1>

            <div className='bg-black rounded-3 p-2 shadow'>
                {isFetchingSingle?
                    <div className=' placeholder-wave'>
                        <p className='fs-5 fw-bold mb-3 placeholder col-9 bg-white'></p>
                        
                        {/* Web view */}
                        <Carousel responsive={responsivePrograms} centerMode={true} infinite={false} className='py-2 d-sm-flex d-none'>
                            {
                                [1,2,3,4].map((num, index) => (
                                    <div key={index}>
                                        <ProgramPlaceholder />
                                    </div>
                                ))
                            }
                        </Carousel>

                        {/* Mobile view */}
                        <div className='d-block d-sm-none'>
                            <div className=' d-flex flex-column'>
                                {
                                    [1,2,3,4].map((num, index) => (
                                        <div key={index}>
                                            <ProgramPlaceholder />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                :
                <div style={{maxWidth: windowWidth > 767 ? max ? 'calc(100vw - 240px)':'calc(100vw - 127px)' : 'calc(100vw - 47px)'}}>
                    <h2 className='fs-5 text-capitalize fw-bold mb-2 text-white'>{format(new Date(singleProgram?.data?.dayAt),"EEEE dd MMM yyy", {locale: fr})} </h2>
                    <div className="d-flex justify-content-start align-items-center mt-3 mb-2 menu">
                        <NavLink to={adminProgrammeEditLink+'/'+singleProgram?.data?.id} className='d-flex align-items-center w-auto px-2 py-1 me-2 mb-2 nav-link border bordercolor-primary rounded-3'>
                            <i className="fa-light fa-pen-to-square me-2 text-white"></i>
                            <span className=' fs-9s text-white'>Modifier</span>
                        </NavLink>
                    </div>

                    {/* Web view */}
                    <Carousel responsive={responsivePrograms} centerMode={true} arrows={true} infinite={false} className='py-2 d-sm-flex d-none' >
                        {
                            singleProgram?.data?.emissions
                            ?.sort((a, b) => a?.startAt?.localeCompare(b?.startAt)) // Classer par heure
                            ?.map((emission) => (
                                <div key={emission?.id}>
                                    <ProgramCard image={emission?.picture} title={emission?.name} date={emission?.startAt?.slice(0,5)} />
                                </div>
                            ))
                        }
                    </Carousel>

                    {/* Mobile view */}
                    <div className='d-block d-sm-none'>
                        <div className=' d-flex flex-column'>
                            {
                                singleProgram?.data?.emissions.map((emission, index) => (
                                    <div key={index}>
                                        <ProgramCard image={emission?.picture} title={emission?.name} date={emission?.startAt?.slice(0,5)} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default ProgrammationDetails